import { useEffect, useState } from 'react';
import { useTheme } from '../contexts/themeContext';
import {
  SECTION3_BACKGROUND_LIGHT_SRC,
  SECTION3_BACKGROUND_SRC,
  SECTION3_FALLBACK_IMAGE,
  SECTION3_IMAGE_BASENAMES,
  SECTION3_IMAGE_EXTENSIONS,
  section3ImageSrc,
} from '../constants/section3Image';
import { probeImage } from '../utils/probeImage';

async function resolveSection3Image(): Promise<string | null> {
  for (const basename of SECTION3_IMAGE_BASENAMES) {
    for (const ext of SECTION3_IMAGE_EXTENSIONS) {
      const src = section3ImageSrc(basename, ext);
      if (await probeImage(src)) return src;
    }
  }

  return null;
}

/** Charge le fond Section 3 (sombre ou clair selon le thème). */
export function useSection3Image() {
  const { isDark } = useTheme();
  const [darkImage, setDarkImage] = useState(SECTION3_BACKGROUND_SRC);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    resolveSection3Image().then((src) => {
      if (!cancelled) {
        if (src) setDarkImage(src);
        else setDarkImage(SECTION3_FALLBACK_IMAGE);
        setReady(true);
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  const image = isDark ? darkImage : SECTION3_BACKGROUND_LIGHT_SRC;

  return { image, ready: isDark ? ready : true };
}
